import Box from '@material-ui/core/Box';
// import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { actions } from 'Onboarding/Dashboard/data';
import { NAV, NAV_ICONS } from './data';
import {
  useHistory,
  useLocation
} from 'react-router-dom/cjs/react-router-dom.min';
import { useQuery } from 'react-query';
import { getMethod } from 'hooks/queries/getHook';
import { useState } from 'react';
import NonAccessibleModal from 'Onboarding/Dashboard/NonAccessibleModal';
import MyedgeLauchPad from 'Onboarding/Dashboard/MyedgeLauchPad';

const TopModulesPopper = ({
  classes,
  isSuccess,
  data,
  open,
  anchorEl,
  handleClose,
  user
}) => {
  const history = useHistory();
  const [isModuleNotAccessed, setIsModuleNotAccessed] = useState(false);

  const [launchPadMyedge, setLaunchPadMyedge] = useState({
    isOpen: false,
    modal: {
      title: '',
      content: [
        {
          content_title: '',
          body: ''
        }
      ]
    }
  });

  const moduleAccess = user?.permissions?.map((el) => el.codename) || [];
  const { data: isLineManager } = useQuery(
    [
      'line-manager',
      {
        route: '/my_team/check_line_manager/'
      }
    ],
    getMethod
  );
  const handlePermission = (app) => {
    if (
      data?.is_owner ||
      moduleAccess.includes(app?.userModule) ||
      app?.userModule === 'access_task' ||
      app?.userModule === 'access_chat' ||
      app?.userModule === 'access_myedge'
    ) {
      if (app?.external_link) {
        isLineManager
          ? window.open(app.link, '_blank')
          : setLaunchPadMyedge({
              isOpen: !launchPadMyedge.isOpen,
              modal: app.modal
            });
      } else {
        history.push(app.link);
      }
      return;
    }
    setIsModuleNotAccessed(true);
  };
  const handleCloseAccessModule = () => {
    setIsModuleNotAccessed(false);
  };
  const navActions = isLineManager
    ? actions
    : actions.filter((action) => action.title !== 'My Team');

  const lastLineLength = navActions.length % 3;
  const noItemOnLastLine = lastLineLength === 0 ? 3 : lastLineLength;

  const lastLineIndexes = Array.from(
    { length: noItemOnLastLine },
    (_, i) => navActions.length - noItemOnLastLine + i
  );

  return (
    <Box className={classes.popoverWrapper}>
      <Popover
        className={classes.test}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Grid
          container
          alignItems='center'
          justifyContent='space-around'
          style={{ textAlign: 'center' }}
          className={classes.menuPopover}
          rowSpacing={2}
          columnSpacing={1}
        >
          {/* <AppModule classes={classes} module={appModules[0]} /> */}
          {isSuccess && data && !data.is_owner
            ? data.permissions.map((permission, index) => (
                <Grid item sm={4} key={permission.codename ?? index}>
                  <Box onClick={() => history.push(NAV[permission.codename])}>
                    {NAV_ICONS[permission.codename]}
                    <Typography className={classes.appMenu}>
                      {permission.name}
                    </Typography>
                  </Box>
                </Grid>
              ))
            : navActions?.map((module, index) => (
                <AppModule
                  key={module.title}
                  classes={classes}
                  noBorder={lastLineIndexes.includes(index)}
                  handlePermission={handlePermission}
                  module={{
                    name: module.title,
                    pathname: module.link,
                    route: module.link,
                    ...module
                  }}
                />
              ))}
        </Grid>
        {/* <Grid container>
          <Grid item sm={12}>
            <Divider />
          </Grid>
        </Grid> */}
        <Grid
          container
          alignItems='center'
          justifyContent='space-between'
          className={classes.menuPopoverFooter}
        >
          <Grid item>
            <img
              src='https://res.cloudinary.com/dgny8sjrg/image/upload/v1638787771/Bizedge_Frontend_Assets/brand_nwno9e.svg'
              alt='bizedge logo'
            />
            {/* <Typography variant='subtitle2'>Product Awesome</Typography> */}
          </Grid>
          {/* <Grid item>
            <Typography fw='600'>V1.0</Typography>
          </Grid> */}
        </Grid>
      </Popover>
      <NonAccessibleModal
        classes={classes}
        isModuleNotAccessed={isModuleNotAccessed}
        handleCloseAccessModule={handleCloseAccessModule}
      />
      <MyedgeLauchPad
        launchPadMyedge={launchPadMyedge}
        setLaunchPadMyedge={setLaunchPadMyedge}
      />
    </Box>
  );
};

export default TopModulesPopper;

const AppModule = ({ classes, module, handlePermission, noBorder }) => {
  const { name, route, icon } = module || {};
  const location = useLocation();
  const isActive = location.pathname.includes(route?.split('?')?.[0]);
  return (
    <Grid item sm={4}>
      <Box
        // onClick={() => window.open(pathname, '_blank')}
        onClick={() => handlePermission(module)}
        style={{
          background: isActive ? '#E0EEF0' : '',
          color: isActive ? '#2898A4' : '',
          borderRadius: isActive ? '10px' : ''
          // borderBottom: !noBorder ? '1px solid #F2F2F2' : null
        }}
        className={[classes.appWrapper, isActive ? 'active' : '']}
      >
        <img
          src={icon}
          style={{ width: '45px', height: '45px' }}
          alt={'app module ' + name}
        />
        <Typography className={classes.appMenu}>{name}</Typography>
      </Box>
    </Grid>
  );
};
